module.exports = __webpack_public_path__ + "img/rendez-vous.1ffea369.png";